import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_einvoice_posting_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  generic_doc_line_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  validation_error: fromDatatype.TextDatatypeInterface;
  queue_status : fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_json: any;
  date_txn: fromDatatype.TimestampTzDatatypeClass;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  doc_reference: fromDatatype.TextDatatypeInterface;
  billing_jso: any;
  delivery_entity_json: any;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
  einvoice_submission_type: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_generic_doc_einvoice_posting_queue_RowClass
  implements bl_fi_generic_doc_einvoice_posting_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    generic_doc_line_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    validation_error: fromDatatype.TextDatatypeInterface;
    queue_status : fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    code_company: fromDatatype.VarcharDatatypeInterface;
    doc_entity_hdr_json: any;
    date_txn: fromDatatype.TimestampTzDatatypeClass;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    doc_ccy: fromDatatype.VarcharDatatypeInterface;
    doc_reference: fromDatatype.TextDatatypeInterface;
    billing_jso: any;
    delivery_entity_json: any;
    amount_tax_gst: fromDatatype.NumericDatatypeInterface;
    original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
    einvoice_submission_type: fromDatatype.VarcharDatatypeInterface;
}
